import { InteractionHistoryFilter } from "@/components/organisms/history/types";

export const getInitialHistoryFilterData = () => {
    return {
        queueIds: [],
        searchText: "",
        handling: [],
        miscellaneous: [],
        types: []
    } as InteractionHistoryFilter;
};